module.exports = __webpack_public_path__ + "static/images/cons-bg.fd2d15ab.png";